// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"184e3e20","453":"a2a82e80","455":"b80d84e0","977":"4a27937c"}[chunkId] + ".chunk.js";
};